export default __webpack_public_path__ + "static/media/MP0068.5aff3ea9.jpg";